<template>
  <div class="brand w-full pb-10">
    <div
      v-if="!banner.loading"
      class="collection-banner-container"
      :style="{
        'background-color': banner.data.background_color || 'rgb(121, 95, 70)',
      }"
      :class="{
        'is-loading': banner.loading,
      }"
    >
      <Banner
        :title="banner.data.name"
        :logo="imgBaseUrl(banner.data.image)"
        :toggle="true"
      >
        <template #header>
          <ol role="list" class="breadcrumb">
            <li>
              <div class="breadcrumb-item">
                <router-link to="/">Home</router-link>
              </div>
            </li>
            <li>
              <div class="breadcrumb-item">
                <span>/&nbsp;</span
                ><router-link to="/categories">Categories</router-link>
              </div>
            </li>
            <li>
              <div class="breadcrumb-item">
                <span>/&nbsp;</span
                ><a href="#" aria-current="page">{{ banner.data.name }}</a>
              </div>
            </li>
          </ol>
        </template>
        <template #footer>
          <div class="-mb-8">
            <Sorting />
            <SortFilterMobile />
          </div>
          <!-- Footer Slot -->
        </template>
      </Banner>
    </div>
    <div v-else class="collection-banner-container is-loading">
      <Banner title="Loading..." logo="" toggle="false">
        <template #header>
          <ol role="list" class="breadcrumb">
            <li>
              <div class="breadcrumb-item">
                <router-link to="/">Home</router-link>
              </div>
            </li>
            <li>
              <div class="breadcrumb-item">
                <span>/&nbsp;</span
                ><router-link to="/categories">Categories</router-link>
              </div>
            </li>
            <li>
              <div class="breadcrumb-item">
                <span>/&nbsp;</span
                ><a href="#" aria-current="page">Loading...</a>
              </div>
            </li>
          </ol>
        </template>
      </Banner>
    </div>
    <div class="py-10 max-container">
      <!-- Listing -->
      <div class="flex items-center space-x-4 pb-5">
        <FilterBadge />
      </div>
      <ListLoaderWrapper :isLoading="category.loading" />
      <ItemsList
        :items="category"
        :loading="category.loading"
        :filter="[]"
        filter_by="brands"
      />
    </div>
    <ListLoaderWrapper :isLoading="category.onScrollLoading" />
  </div>
</template>

<script>
import Banner from "../common/Banner.vue";
import ItemsList from "../common/ItemsList.vue";
import Categories from "@/modules/Categories";
import ListLoaderWrapper from "@/components/loaders/ListLoaderWrapper.vue";
import { useStore, mapGetters } from "vuex";
import SortFilterMobile from "@/components/SortFilterMobile.vue";
import { watch, computed } from "vue";
import { useRoute } from "vue-router";

export default {
  name: "Home",
  components: {
    Banner,
    ItemsList,
    ListLoaderWrapper,
    SortFilterMobile,
  },
  beforeMount() {
    this.$store.dispatch("getCart", { ax: null });
  },
  beforeRouteLeave() {
    this.saveScrollState();
  },
  beforeUnmount() {
    this.$store.dispatch("removeOption", "clear");
    this.$store.dispatch("setSort", {
      previous: "",
      current: "",
    });
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const imgBaseUrl = (image) => {
      if (image === null) {
        return "/images/no-image.png";
      }
      const base_url_img = process.env.BASE_URL_IMG || "/";
      return base_url_img + "/" + image.path;
    };

    const {
      category,
      banner,
      getBanner,
      maxPrice,
      getData,
      reset,
      saveScrollState,
      restoreScrollState,
    } = Categories();
    getBanner();
    maxPrice();
    
    const isThisPage = computed(() => route.name === "CatSlug");
    let isFirstLoad = true;
    watch(
      () => [route.query, isThisPage.value],
      async ([query, onPage]) => {
        if (!onPage) return;
        reset();
        if(query.sort){
          store.dispatch("setSort", {
            previous: store.getters.getSort.current,
            current: query.sort || "default",
          });
          console.log("sort from query", query.sort);
        }
        if (isFirstLoad) {
          isFirstLoad = false;
          const restored = await restoreScrollState();
          if (restored === true) return; // data load + scroll handled by restore
          category.data = await getData("loading");
          if (restored) {
            await nextTick();
            requestAnimationFrame(() => window.scrollTo({ top: restored, behavior: 'smooth' }));
          }
        } else {
          category.data = await getData("loading");
        }
      },
      { deep: true, immediate: true }
    );

    const currentShipping = computed(() => store.getters.getSelectedAddress);

    watch(currentShipping, async () => {
      if (store.getters.getAddressChange) {
        store.dispatch("setAddressChange", false);
        reset();
        category.data = await getData("loading");
      }
    });

    return {
      imgBaseUrl,
      banner,
      category,
      saveScrollState,
    };
  },
};
</script>

<style lang="scss" scoped>
.collection-banner-container {
  background-image: url("/images/lines-pattern.png");

  &.is-loading {
    @apply bg-gray-100 bg-opacity-50 #{!important};
  }
}
</style>
